import React from 'react'
import styled from 'styled-components'
import { PrimitiveAtom, useAtom } from 'jotai'
import ActiveFilterChip from '@/components/activeFilterChip/ActiveFilterChip'
import {
    selectedFilterPortfolioAtexAtom,
    selectedFilterPortfolioIpRatingAtom,
    selectedFilterPortfolioMeasureTypeAtom,
    selectedFilterPortfolioProtocolAtom,
    selectedFilterPortfolioVendorAtom,
} from '@/core/store/globalStore'

const CHIP_ATOMS: PrimitiveAtom<string | null>[] = [
    selectedFilterPortfolioVendorAtom,
    selectedFilterPortfolioMeasureTypeAtom,
    selectedFilterPortfolioAtexAtom,
    selectedFilterPortfolioProtocolAtom,
    selectedFilterPortfolioIpRatingAtom,
]

const PortfolioFilterChip: React.FC<{ atom: PrimitiveAtom<string | null> }> = ({ atom }) => {
    const [value, setValue] = useAtom(atom)
    if (!value) return null
    return <ActiveFilterChip onDelete={() => setValue(null)}>{value}</ActiveFilterChip>
}

const PortfolioChipRow: React.FC = () => (
    <Row>
        {CHIP_ATOMS.map((atom) => (
            <PortfolioFilterChip key={atom.toString()} atom={atom} />
        ))}
    </Row>
)

const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 8px;
    margin-top: 8px;

    &:empty {
        margin-top: 0;
    }
`

export default PortfolioChipRow
